import React, {useEffect, useState} from 'react'
import { Card, CardBody } from 'reactstrap'
import Bowser from "bowser";

const InfoCard = (props) => {
	const browser = Bowser.getParser(window.navigator.userAgent)
	const [isAltDevice, setIsAltDevice] = useState(false)

	useEffect(() => {
		const checkDevice = () => {
			if (browser.getPlatformType() === 'tablet' || browser.getPlatformType() === 'mobile')
				setIsAltDevice(true)
		}
		checkDevice()
	}, [browser])

	return (
		<React.Fragment>
			<Card className="main-card mb-3 ck-content overflow-auto">
				<CardBody>
					{props.longinfo ?
						<div dangerouslySetInnerHTML={{__html: props.longinfo}} />
						: <p>Än så länge finns ingen ytterligare information</p>
					}
					{props.infoimage_url__pc &&
						<img  src={props.infoimage_url__pc} alt="Lärarbild" />
					}
					{props.topinfo && isAltDevice ? <div className="text-danger my-2">Se till att inställningarna för din surfplatta tar emot PDF-filerna genom att aktivera popup-fönster.</div> : null}
				</CardBody>
			</Card>
		</React.Fragment>
	)
}

export default InfoCard
